import type * as React from 'react';

/**
 Generated using: https://react-svgr.com/playground

 How to import new SVGs:
 1. open the SVG in a text editor
 2. copy the <svg ...>  </svg> portion and replace the same section in this file, keeping the {...props}
 3. remove xmlns:xlink attribute from root svg element
 4. replace all xlink:href attributes with href
 5. replace all `fontFamily="Roboto-????, Roboto"` with matching `fontFamily="Roboto-????, Roboto, Helvetica Neue, HelveticaNeue, Helvetica, Arial, sans-serif"`
*/

const SaveTime = () => (
  <svg
    width="128"
    height="128"
    viewBox="0 0 129 128"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.9072 66.0732H16.0283C14.8838 66.0732 13.9551 65.145 13.9551 64C13.9551 62.855 14.8838 61.9268 16.0283 61.9268H20.9072C22.0518 61.9268 22.9805 62.855 22.9805 64C22.9805 65.145 22.0518 66.0732 20.9072 66.0732Z"
      fill="#FDC221"
    />
    <path
      d="M21.2334 75.0537H10.5C9.35547 75.0537 8.42676 74.1255 8.42676 72.9805C8.42676 71.8354 9.35547 70.9072 10.5 70.9072H21.2334C22.3779 70.9072 23.3066 71.8354 23.3066 72.9805C23.3066 74.1255 22.3779 75.0537 21.2334 75.0537Z"
      fill="#FDC221"
    />
    <path
      d="M20.9072 84.0332H16.0283C14.8838 84.0332 13.9551 83.105 13.9551 81.96C13.9551 80.8149 14.8838 79.8867 16.0283 79.8867H20.9072C22.0518 79.8867 22.9805 80.8149 22.9805 81.96C22.9805 83.105 22.0518 84.0332 20.9072 84.0332Z"
      fill="#FDC221"
    />
    <path
      d="M73.9861 28.0625H62.1797V37.9367H73.9861V28.0625Z"
      fill="#F470BD"
    />
    <path
      d="M76.49 16H59.676C57.6091 16 55.9336 17.6755 55.9336 19.7424V24.32C55.9336 26.3868 57.6091 28.0623 59.676 28.0623H76.49C78.5569 28.0623 80.2324 26.3868 80.2324 24.32V19.7424C80.2324 17.6755 78.5569 16 76.49 16Z"
      fill="#0D3880"
    />
    <path
      d="M38.0406 36.2225L35.4916 38.7712C34.7007 39.562 34.7007 40.8443 35.4915 41.6351L43.736 49.8804C44.5268 50.6713 45.809 50.6714 46.5999 49.8806L49.1489 47.3318C49.9398 46.541 49.9398 45.2588 49.149 44.4679L40.9045 36.2226C40.1137 35.4317 38.8314 35.4317 38.0406 36.2225Z"
      fill="#0D3880"
    />
    <path
      d="M94.5626 34.204L86.3177 42.4489C85.5269 43.2397 85.5268 44.522 86.3177 45.3128L88.8665 47.8617C89.6574 48.6525 90.9396 48.6525 91.7305 47.8617L99.9754 39.6168C100.766 38.8259 100.766 37.5437 99.9754 36.7528L97.4265 34.204C96.6357 33.4131 95.3535 33.4131 94.5626 34.204Z"
      fill="#0D3880"
    />
    <path
      d="M68.5 112C90.2171 112 107.822 94.3949 107.822 72.6778C107.822 50.9607 90.2171 33.3555 68.5 33.3555C46.7829 33.3555 29.1777 50.9607 29.1777 72.6778C29.1777 94.3949 46.7829 112 68.5 112Z"
      fill="#EE399E"
    />
    <path
      d="M68.5003 100.01C83.5955 100.01 95.8326 87.7732 95.8326 72.678C95.8326 57.5828 83.5955 45.3457 68.5003 45.3457C53.4051 45.3457 41.168 57.5828 41.168 72.678C41.168 87.7732 53.4051 100.01 68.5003 100.01Z"
      fill="white"
    />
    <path
      d="M69.4707 51.0303H67.4707V54.5488H69.4707V51.0303Z"
      fill="#B6C7E0"
    />
    <path
      d="M69.4707 89.3203H67.4707V92.8389H69.4707V89.3203Z"
      fill="#B6C7E0"
    />
    <path d="M89.375 70.9355H85.8564V72.9355H89.375V70.9355Z" fill="#B6C7E0" />
    <path d="M51.085 70.9355H47.5664V72.9355H51.085V70.9355Z" fill="#B6C7E0" />
    <path
      d="M68.5002 74.1966C68.1116 74.1966 67.7229 74.0482 67.426 73.7518C66.8333 73.1586 66.8333 72.1967 67.426 71.6039L81.2776 57.7518C81.8713 57.1581 82.8323 57.1586 83.426 57.7513C84.0188 58.3446 84.0188 59.3065 83.426 59.8993L69.5745 73.7513C69.2776 74.0482 68.8889 74.1966 68.5002 74.1966Z"
      fill="#EE399E"
    />
    <path
      d="M68.5 76.9641C70.8672 76.9641 72.7862 75.0451 72.7862 72.6778C72.7862 70.3106 70.8672 68.3916 68.5 68.3916C66.1328 68.3916 64.2137 70.3106 64.2137 72.6778C64.2137 75.0451 66.1328 76.9641 68.5 76.9641Z"
      fill="#0D3880"
    />
  </svg>
);

export { SaveTime };
